import { render, staticRenderFns } from "./InvestmentProfileSidebar.vue?vue&type=template&id=53308af0&scoped=true"
import script from "./InvestmentProfileSidebar.vue?vue&type=script&lang=js"
export * from "./InvestmentProfileSidebar.vue?vue&type=script&lang=js"
import style0 from "./InvestmentProfileSidebar.vue?vue&type=style&index=0&id=53308af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53308af0",
  null
  
)

export default component.exports